module.exports = __webpack_public_path__ + "media/images/new_home/community-0b7ef95150682d448ca7a6b07693ccaf.png";